// eslint-disable-next-line import/prefer-default-export
export const PropertiesActionTypes = {
  SET_STATES: 'SET_STATES',
  SET_SELECTED_STATE: 'SET_SELECTED_STATE',
  SET_SELECTED_PROPERTY: 'SET_SELECTED_PROPERTY'
};
